import React from 'react';
import PropTypes from 'prop-types';
import { useSelectionHomeScore, useSelectionAwayScore } from '~SpectateStore/hooks/selectionsHooks';
import BetButtonSelection from './BetButtonSelection';
import './styles/selection.scss';

const CellSelectionUS = ({ id, sectionKey }) => {
    const homeScore = useSelectionHomeScore(id);
    const awayScore = useSelectionAwayScore(id);

    return (
        <div id={id} className="cell-selection">
            <div>
                {sectionKey === 'home' && `${homeScore}-${awayScore}`}
                {sectionKey === 'away' && `${awayScore}-${homeScore}`}
                {sectionKey === 'draw' && `${homeScore}-${awayScore}`}
            </div>
            <div>
                <BetButtonSelection id={id}/>
            </div>
        </div>
    );
};

CellSelectionUS.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    sectionKey : PropTypes.string.isRequired,
};

export default CellSelectionUS;
